export async function eventId(
  modulename: string,
  objecttype: string,
  action: string
): Promise<string> {
  const orgId = localStorage.getItem("crm_orgid");

  const userData = localStorage.getItem(`${orgId}.domain`) || "";

  const applicationName = userData;

  return `event_${applicationName}_${objecttype}_${modulename}_${action}`.toLowerCase();
}
